import { Component } from '@angular/core';
import {select, Store} from "@ngrx/store";
import {UsersSelectors} from "../../../store/selectors";
import {UsersActions} from "../../../store/actions";
import {animate, style, transition, trigger} from "@angular/animations";
import {UserStatusEnum} from "@esa/api";

@Component({
  selector: 'app-support-component-controller',
  templateUrl: './support-controller.component.html',
  styleUrls: ['./support-controller.component.scss'],
  animations: [
    trigger('fadeIn', [
      transition(':enter', [
        style({ opacity: 0 }),
        animate('1000ms', style({ opacity: 1 })),
      ]),
    ]),
  ],
  host: {
    class:'routed',
    '[@fadeIn]': ''
  }
})
export class SupportControllerComponent {
  loggedInUser$ = this._store.pipe(select(UsersSelectors.getLoggedInUser));
  users$ = this._store.select(UsersSelectors.getUsers);


  constructor (private _store: Store) {
    this._store.dispatch(UsersActions.getLoggedInUser());
    this._store.dispatch(UsersActions.getUsers({ pageNumber: 1, pageSize: 10, userStatus: 'Active' as UserStatusEnum }));
  }
}
